import React from 'react';
import { FaPhone, FaWhatsapp, FaYoutube, FaInstagram, FaFacebook } from 'react-icons/fa';
import Page from '../components/Page';
import { PHONE, PHONE_HREF, WHATSAPP_HREF, SOCIALS } from '../site';
import { track } from '../analytics';

const socialIcons = {
  youtube: FaYoutube,
  instagram: FaInstagram,
  facebook: FaFacebook,
};

const Contact = () => (
  <Page title="Contact">
    <p className="leading-relaxed text-gray-700">
      Questions about a class, or ready to sign up? Reach us any of these ways.
    </p>

    <ul className="mt-8 flex flex-col gap-4 text-lg">
      <li>
        <a href={PHONE_HREF} onClick={() => track('Contact')} className="flex items-center gap-3 text-navy hover:underline">
          <FaPhone aria-hidden="true" /> {PHONE}
        </a>
      </li>
      <li>
        <a
          href={WHATSAPP_HREF}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Contact')}
          className="flex items-center gap-3 text-navy hover:underline"
        >
          <FaWhatsapp aria-hidden="true" /> Message us on WhatsApp
        </a>
      </li>
    </ul>

    <h2 className="mb-4 mt-12 text-2xl font-bold text-navy">Follow us</h2>

    <ul className="flex flex-col gap-4 text-lg">
      {SOCIALS.map(({ id, label, url }) => {
        const Icon = socialIcons[id];
        return (
          <li key={id}>
            {url ? (
              <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-3 text-navy hover:underline"
              >
                <Icon aria-hidden="true" /> {label}
              </a>
            ) : (
              <span className="flex items-center gap-3 text-gray-400">
                <Icon aria-hidden="true" /> {label} &mdash; coming soon
              </span>
            )}
          </li>
        );
      })}
    </ul>
  </Page>
);

export default Contact;
